import React, { useState, useEffect } from "react";

const Hero = ({ scrollToSection }) => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="bg-image bg-image-1">
          <img src="/assets/vasundhara/1.png" alt="Vision Background 1" />
        </div>
        <div className="bg-image bg-image-2">
          <img src="/assets/projectnirmal/4.png" alt="Vision Background 2" />
        </div>
        <div className="hero-overlay"></div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-title-section">
            <h2>
              🌱 स्वच्छ कटनी, स्वस्थ कटनी
              <span className="highlight"> - Vision के साथ</span>
            </h2>
            <p>
              हमारे साथ जुड़िए शहर की सफाई और पर्यावरण संरक्षण के महान कार्य
              में। एक साथ मिलकर बनाएं एक स्वच्छ, हरित और सुंदर कटनी।
            </p>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">1500+</span>
              <span className="stat-label">🌳 पौधे रोपित</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">7</span>
              <span className="stat-label">🚀 सक्रिय प्रोजेक्ट्स</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">🧹 सफाई क्षेत्र</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1000+</span>
              <span className="stat-label">👥 लाभान्वित नागरिक</span>
            </div>
          </div>

          <div className="hero-buttons">
            <button
              className="cta-button"
              onClick={() => scrollToSection("projects")}
            >
              🚀 हमारे प्रोजेक्ट्स देखें
            </button>
            <button
              className="cta-button secondary"
              onClick={() => scrollToSection("about")}
            >
              ℹ️ हमारे बारे में जानें
            </button>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        className={`fab scroll-to-top ${showScrollTop ? "visible" : ""}`}
        onClick={scrollToTop}
        title="वापस टॉप पर जाएं"
      >
        ↑
      </button>
    </section>
  );
};

export default Hero;
